// extracted by mini-css-extract-plugin
export default {"mainContainer":"TeamImagesCarousel_mainContainer__+k+2N"};